<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5162 4.93845V3H15.7742V4.93845H12.871V3H11.129V4.93845H8.22582V3H6.48387V4.93845H3V21H21V4.93845H17.5162ZM19.2581 19.3384H4.74195V8.81537H19.2581V19.3384Z"
      class="fill-current"
    />
    <path d="M9.38711 11.5846H7.64516V13.2462H9.38711V11.5846Z" class="fill-current" />
    <path d="M12.871 11.5846H11.129V13.2462H12.871V11.5846Z" class="fill-current" />
    <path d="M16.3549 11.5846H14.6129V13.2462H16.3549V11.5846Z" class="fill-current" />
    <path d="M9.38711 14.9077H7.64516V16.5693H9.38711V14.9077Z" class="fill-current" />
    <path d="M12.871 14.9077H11.129V16.5693H12.871V14.9077Z" class="fill-current" />
    <path d="M16.3549 14.9077H14.6129V16.5693H16.3549V14.9077Z" class="fill-current" />
  </svg>
</template>
